import { render, staticRenderFns } from "./AddEditCompanies.vue?vue&type=template&id=746712f6&"
import script from "./AddEditCompanies.vue?vue&type=script&lang=js&"
export * from "./AddEditCompanies.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCompanies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports